import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import { CURRENCIES } from '@global/constants'

import Counter from '../../../../../../../../../../../components/Counter'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../constants'

import './styles.scss'

@injectIntl
export default class CounterRow extends Component {
    static propTypes = {
        intl: PropTypes.object,
        summary: PropTypes.object,
        selector: PropTypes.string.isRequired,
    }

    renderCounter = (amount, currency) => {
        const { intl, selector } = this.props

        return (
            <Counter
                leftValue={{
                    value: (
                        <Money
                            decimalPlaces={0}
                            emptyValue={0}
                            value={{
                                amount,
                                currency,
                            }}
                            currencyStyle={{
                                fontFamily: 'Trivia Sans Hairline',
                                fontSize: '36px',
                            }}
                        />
                    ),
                }}
                description={intl.formatMessage(
                    {
                        id: `${LOCALE_PREFIX}.counterDescription.${selector}`,
                    },
                    { br: <br /> }
                )}
            />
        )
    }

    render() {
        const { summary } = this.props

        return (
            <>
                {(!_.isNil(summary?.procurementSumInCzk) || !_.isNil(summary?.procurementSumInEur)) && (
                    <div className={'public-tenders-counters-wrapper'}>
                        {!_.isNil(summary?.procurementSumInCzk) &&
                            this.renderCounter(summary?.procurementSumInCzk, CURRENCIES.CZK)}
                        {!_.isNil(summary?.procurementSumInEur) &&
                            this.renderCounter(summary?.procurementSumInEur, CURRENCIES.EUR)}
                    </div>
                )}
            </>
        )
    }
}
